import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import GetAppIcon from '@mui/icons-material/GetApp';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { withStyles } from '@mui/styles';
import {
  getAllProjects,
  getProjectBilling,
  getProjectStatus,
  searchProjectFilter,
  searchProjects
} from 'src/services/projectDetailService';
import { ProjectFilter } from 'src/models/project_details';
import { useForm } from 'react-hook-form';
import styled from '@emotion/styled';
import {
  filterActualHours,
  getActualHours,
  searchActualHours
} from 'src/services/timesheetService';

interface Filters {
  type: string;
  po_status: string;
  status: string;
  cat: string;
}

const applyFilters = (projectList: any[], filters: Filters): any[] => {
  return projectList.filter((employeeStatus) => {
    let matches = true;
    // if (filters.status && employeeStatus.status !== filters.status) {
    //   matches = false;
    // }
    return matches;
  });
};

const applyPagination = (
  projectList: any[],
  page: number,
  limit: number
): any[] => {
  return projectList.slice(page * limit, page * limit + limit);
};

const ActualHoursTable = () => {
  const navigate = useNavigate();
  const [toggleFilter, setToggleFilter] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [sortIdType, setSortIdType] = useState('desc');
  const [sortNameType, setSortNameType] = useState('asc');
  const [filters, setFilters] = useState<Filters>({
    type: null,
    po_status: null,
    status: null,
    cat: null
  });
  var initalList: any[] = [];
  var [projectList, setProjects] = useState(initalList);

  let initialProjectFilterValues = {
    type: null,
    client: null,
    projectStatus: null,
    week: null
  } as any;

  const { register, handleSubmit, reset, getValues, setValue } = useForm<any>({
    defaultValues: initialProjectFilterValues
  });
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (projectList?.length > 0 && sortIdType === 'asc') {
      setProjects(projectList.sort((a, b) => a.client.localeCompare(b.client)));
    } else if (projectList?.length > 0 && sortIdType === 'desc') {
      setProjects(projectList.sort((a, b) => b.client.localeCompare(a.client)));
    }
  }, [projectList, sortIdType]);

  useEffect(() => {
    if (projectList?.length > 0 && sortNameType === 'asc') {
      setProjects(
        projectList.sort((a, b) => a.projectName.localeCompare(b.projectName))
      );
    } else if (projectList?.length > 0 && sortNameType === 'desc') {
      setProjects(
        projectList.sort((a, b) => b.projectName.localeCompare(a.projectName))
      );
    }
  }, [sortNameType]);

  const filteredProject = applyFilters(projectList, filters);

  const paginatedProject = applyPagination(filteredProject, page, limit);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const [clientNames, setClientNames] = useState([]);

  const getAllProjectDetails = () => {
    getActualHours()
      .then((result) => {
        const projects = result.data.map((proj) => proj.client);
        setClientNames(
          projects.filter((c, index) => {
            return projects.indexOf(c) === index;
          })
        );
        setProjects((result.data as any[]) || []);
      })
      .catch((err) => {
        console.log(err);
      });
    // getAllProjects().then((res) => {
    //   setProjects((res.data as any[]) || []);
    // });
  };

  useEffect(() => {
    getAllProjectDetails();
  }, []);

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const [proFilter, setProFilter] = useState({} as any);

  const onSubmit = (data: ProjectFilter) => {
    filterActualHours(data).then((res) => {
      setProjects((res.data as any[]) || []);
    });
  };

  const resetFilterResult = () => {
    reset();
    setProFilter(initialProjectFilterValues);
    getAllProjectDetails();
  };

  const [billingCategories, setbillingCategories] = useState([]);
  const [projectStatus, setprojectStatus] = useState([]);

  const getAllProjectDropdowns = () => {
    getProjectBilling().then((res) => {
      setbillingCategories(res.data);
    });
    getProjectStatus().then((res) => {
      setprojectStatus(res.data);
    });
  };

  useEffect(() => {
    getAllProjectDropdowns();
  }, []);

  const [searchKeywords, setSearchKeywords] = useState('');

  //when user started to type the name in the text field
  const nameChange = (event) => {
    setSearchKeywords(event.target.value);
  };

  const searchGroupsAll = async (keyword: string) => {
    const result = await searchActualHours(keyword);
    setProjects(result?.data);
  };

  useEffect(() => {
    if (searchKeywords.length > 3) {
      searchGroupsAll(searchKeywords);
    }
    if (searchKeywords.length === 0) {
      getAllProjectDetails();
    }
  }, [searchKeywords]);

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
    .MuiCardHeader-action{
      width: 100%
    }
  `
  );

  useEffect(() => {
    const isNullish = Object.values(proFilter).every((value) => {
      if (value === null) {
        return true;
      }

      return false;
    });

    if (Object.keys(proFilter).length === 0 || isNullish) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [proFilter]);

  return (
    <>
      <PageTitleWrapper>
        <Grid container alignItems="center" direction={'row'}>
          <Grid item>
            <Typography
              onClick={() => {
                navigate('/dashboard');
              }}
              style={{ cursor: 'pointer' }}
              variant="h4"
              component="h4"
            >
              {' '}
              Dashboard /&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h4"
              component="h4"
            >
              Actual Hrs Distribution
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-end"
            style={{ marginLeft: 'auto' }}
          >
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              startIcon={<GetAppIcon fontSize="small" />}
              style={{ height: '1.75rem' }}
              // onClick={handleClickOpen}
            >
              Download Report
            </Button>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Card>
          <Grid
            container
            style={{
              justifyContent: 'space-between',
              padding: '1rem 1rem 0rem 1rem'
            }}
            spacing={2}
          >
            <Grid item xs={6}>
              <TextField
                sx={{ width: 150, mr: 2 }}
                size="small"
                placeholder="Search..."
                onChange={(e) => nameChange(e)}
                InputProps={{
                  style: { fontSize: '12px', height: '1.75rem' },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{ color: '#d3d3d3' }}
                        style={{ fontSize: '15px' }}
                      />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                sx={{
                  mt: { xs: 2, md: 0 },
                  color: `${!toggleFilter && 'gray'}`
                }}
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => {
                  setToggleFilter(!toggleFilter);
                }}
                style={{ height: '1.75rem', fontSize: '12px' }}
              >
                Filters
              </Button>
            </Grid>
          </Grid>
          <CardHeaderWrapper
            action={
              <>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {toggleFilter ? (
                    <>
                      <Grid
                        container
                        sx={{ pr: 2 }}
                        spacing={2}
                        style={{
                          paddingTop: 3,
                          paddingBottom: 2,
                          justifyContent: 'space-between'
                        }}
                      >
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Client
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={proFilter.client}
                              {...register('client')}
                              onChange={(e) => {
                                setProFilter((prev) => ({
                                  ...prev,
                                  client: e.target.value
                                }));
                                setValue('client', e.target.value);
                              }}
                            >
                              {clientNames?.map((client) => (
                                <MenuItem value={client}>{client}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Project Type
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              {...register('type')}
                              value={proFilter.type}
                              onChange={(e) => {
                                setProFilter((prev) => ({
                                  ...prev,
                                  type: e.target.value
                                }));
                                setValue('type', e.target.value);
                              }}
                            >
                              <MenuItem value="Client-Local">
                                Client-Local
                              </MenuItem>
                              <MenuItem value="Client-Foreign">
                                Client-Foreign
                              </MenuItem>
                              <MenuItem value="Internal">Internal</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Project Status
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={proFilter.projectStatus}
                              {...register('projectStatus')}
                              onChange={(e) => {
                                setProFilter((prev) => ({
                                  ...prev,
                                  projectStatus: e.target.value
                                }));
                                setValue('projectStatus', e.target.value);
                              }}
                            >
                              {(projectStatus || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Week
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={proFilter.week}
                              {...register('week')}
                              onChange={(e) => {
                                setProFilter((prev) => ({
                                  ...prev,
                                  week: e.target.value
                                }));
                                setValue('week', e.target.value);
                              }}
                            >
                              {(billingCategories || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{ pr: 2 }}
                        container
                        style={{ justifyContent: 'flex-end', marginTop: 4 }}
                        xs={12}
                      >
                        <Button
                          sx={{ mt: { xs: 2, md: 0 }, mr: 2 }}
                          variant="text"
                          onClick={resetFilterResult}
                          disabled={isDisabled}
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Clear
                        </Button>
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          disabled={isDisabled}
                          variant="outlined"
                          type="submit"
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Filter
                        </Button>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                </form>
              </>
            }
            title=""
          />
          <TableContainer className="tableContainer">
            <Table size="small">
              <TableHead>
                <CustomTableRow>
                  <TableHeaderCell
                    smallFont
                    content="Client"
                    sort
                    setSortType={setSortIdType}
                    sortType={sortIdType}
                  />
                  <TableHeaderCell smallFont content="Project Status" />
                  <TableHeaderCell
                    smallFont
                    content="Project Name"
                    sort
                    setSortType={setSortNameType}
                    sortType={sortNameType}
                  />{' '}
                  <TableHeaderCell content="Project Type" smallFont />
                  <TableHeaderCell content="Planned Hours" smallFont />
                  <TableHeaderCell content="BA" smallFont />
                  <TableHeaderCell content="Dev" smallFont />
                  <TableHeaderCell content="PM" smallFont />
                  <TableHeaderCell content="QA" smallFont />
                  <TableHeaderCell content="SM" smallFont />
                  <TableHeaderCell content="Dec" smallFont />
                  <TableHeaderCell content="Total Actual Hours" smallFont />
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {paginatedProject &&
                  paginatedProject?.length > 0 &&
                  paginatedProject.map((listItem) => {
                    return (
                      <TableRow hover key={listItem.code}>
                        <TableCell>
                          <Typography
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.client}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            onClick={() => {
                              // setEditData(listItem);
                              // setIsEdit(true);
                              // toggleModal();
                            }}
                            gutterBottom
                            noWrap
                          >
                            {listItem?.projectStatus}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.projectName}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.type}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.plannedHours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.bAhours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.deVhours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.pMhours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.qAhours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.sMhours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.otherhours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.totalWorkedHours}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* {paginatedProject?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )} */}
          <Box p={2}>
            <TablePagination
              sx={{
                fontSize: '12px',
                '.MuiTablePagination-displayedRows': {
                  fontSize: '12px'
                },
                '.MuiTablePagination-selectLabel': {
                  fontSize: '12px'
                }
              }}
              component="div"
              count={filteredProject?.length}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default ActualHoursTable;
